import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    updates: [
      { id: 0, title: "Hello, World!", subtitle: "01/21/2019 - Preface", component: "0", image: "updates/0/almost.png" },
      { id: 1, title: "Checkpoint 1", subtitle: "01/21/2019 - Setting the Scene", component: "1", image: "updates/1/recreation.png" },
      { id: 2, title: "Project Plan", subtitle: "01/24/2019 - Getting Started", component: "2", image: "updates/2/domain_model.png" },
      { id: 3, title: "Checkpoint 2", subtitle: "02/10/2019 - Framework", component: "3", image: "updates/3/basicrender.png" },
      { id: 4, title: "Updated Design", subtitle: "02/14/2019 - Design", component: "4", image: "updates/4/expanded_framework.png" },
      { id: 5, title: "Checkpoint 3", subtitle: "02/26/2019 - Phong", component: "5", image: "updates/5/basic_image.png" },
      { id: 6, title: "Design & Next Steps", subtitle: "02/27/2019", component: "6", image: "updates/6/updated_framework.png" },
      { id: 7, title: "Checkpoint 4", subtitle: "03/23/2019 - Textures", component: "7", image: "updates/7/checkerboard.png" },
      { id: 8, title: "Checkpoint 5", subtitle: "04/02/2019 - Reflection", component: "8", image: "updates/8/reflection.png" },
      { id: 9, title: "Checkpoint 6", subtitle: "04/17/2019 - Refraction", component: "9", image: "updates/9/colors_2.png" },
      { id: 10, title: "Checkpoint 7", subtitle: "05/04/2019 - Tone Reproduction", component: "10", image: "updates/10/9_reinhard_015.png" },
      { id: 11, title: "Advanced #1", subtitle: "05/07/2019 - Tone Reproduction", component: "11", image: "updates/11/log_1.png" },
      { id: 12, title: "Advanced #2", subtitle: "05/07/2019 - OSL & Blender", component: "12", image: "updates/12/purple.png" },
    ],
  },
  mutations: {

  },
  actions: {

  },
});
